import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchHarvestedBatch(organization_id, harvested_batch_id) {
    return RequesterV1.get(
      `organization/process/packing/manage_package/${organization_id}/fetch_harvested_batch/${harvested_batch_id}`
    );
  },
  fetchPackage(organization_id, harvested_batch_id, package_id) {
    return RequesterV1.get(
      `organization/process/packing/manage_package/${organization_id}/fetch_package/${harvested_batch_id}/${package_id}`
    );
  },
  create(organization_id, harvested_batch_id, package_params) {
    return RequesterV1.post(
      `organization/process/packing/manage_package/${organization_id}/create/${harvested_batch_id}`,
      { package: package_params }
    );
  },
  update(organization_id, harvested_batch_id, package_id, package_params) {
    return RequesterV1.post(
      `organization/process/packing/manage_package/${organization_id}/update/${harvested_batch_id}/${package_id}`,
      { package: package_params }
    );
  },
  destroy(organization_id, harvested_batch_id, package_id) {
    return RequesterV1.delete(
      `organization/process/packing/manage_package/${organization_id}/destroy/${harvested_batch_id}/${package_id}`
    );
  }
};
